<template>
  <form @submit.prevent="handleSubmit" class="media">
    <figure class="media-left">
      <p v-if="form.user_role === 'user'" class="image is-64x64">
        <img v-if="user" :src="user.profile_picture.sm" class="is-rounded" :alt="user.name" />
        <img v-else src="/images/md-user.jpg" class="is-rounded" />
      </p>

      <p v-if="form.user_role === 'moderator'" class="image is-64x64">
        <img src="/images/logos/mplus.jpg" class="is-rounded" />
      </p>
    </figure>

    <div class="media-content">
      <div v-if="user" class="field is-horizontal">
        <b-select v-model="form.user_role" size="is-small">
          <option value="user">User/option></option>
          <option value="moderator">M+ тусламжийн алба</option>
        </b-select>
      </div>

      <b-field expanded>
        <b-input
          ref="input"
          type="textarea"
          placeholder="Сэтгэгдэл бичих ..."
          rows="3"
          v-model="form.comment"
          expanded
          :readonly="user === null"
          @focus="onClick"
        ></b-input>
      </b-field>

      <div v-if="form.comment.length > 0">
        <button
          class="button is-primary is-medium"
          :class="{ 'is-loading': form.processing }"
        >Илгээх</button>

        <button type="button" class="button is-white is-medium" @click="cancel">Цуцлах</button>
      </div>
    </div>
  </form>
</template>

<script>
import { mapState } from "vuex";

export default {
  props: {
    type: {
      type: String,
      required: true
    },

    id: {
      type: String,
      required: true
    },

    userRole: {
      type: String,
      default: "user"
    },

    autofocus: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      active: false,

      form: new window.Form({
        reviewable_type: this.type,
        reviewable_id: this.id,
        comment: "",
        user_role: this.userRole
      })
    };
  },

  computed: mapState({
    user: state => state.auth.user
  }),

  mounted() {
    if (this.autofocus) {
      this.$refs.input.focus();
    }
  },

  methods: {
    handleSubmit() {
      this.form
        .takeAtLeast(500)
        .post("/api/reviews")
        .then(({ message, data }) => {
          this.$buefy.toast.open(message);

          this.form.comment = "";

          this.$emit("commented", data);
        });
    },

    onClick() {
      if (!this.$store.getters.signedIn) {
        this.$buefy.toast.open("Та сэтгэгдэл бичихийн тулд нэвтэрнэ үү.");
      }
    },

    cancel() {
      this.form.comment = "";

      this.$emit("cancelled");
    }
  }
};
</script>
